import { openAccountDlg } from '../dialogs/accountDlg';
import { openClientListDlg } from '../dialogs/clientListDlg';
import { openGuidelines } from '../dialogs/guidelines';
import { openHistory } from '../dialogs/history';
import { openInbox } from '../dialogs/inbox';
import { openLoginDlg } from '../dialogs/loginDlg';
import { openPostingDlg } from '../dialogs/postingDlg';
import { openSubscriptionsDlg } from '../dialogs/subscriptionsDlg';
import { openUserOrgList } from '../dialogs/userOrgListDlg';
import { openUserPostings } from '../dialogs/userPostings';
import { dlg } from '../dlg';
import { state } from '../services/state';

export function Navbar() {
	return (
		<div id="title">
			<div class="inner flex gap20 center">
				<a href="/">
					<img class="large" src="/icons8-help-50.png" />
				</a>
				<a href="/" style={{ 'font-size': '20px', color: 'white', 'text-decoration': 'none' }}>
					Bit of Help
				</a>
				<span class="grow" />

				<a
					style={{
						'font-size': '24px',
						'text-decoration': 'none',
						color: state.dark ? 'white' : 'yellow',
						'margin-bottom': '4px'
					}}
					onClick={(e) => state.set_theme(true)}
				>
					☀
				</a>

				<a class="large" onClick={openGuidelines}>
					Guidelines
				</a>

				{/* <button
					id="bt_create_posting"
					onClick={async (e) => {
						let p = await openPostingDlg(null);
						if (p) state.refreshList();
					}}
				>
					Create Posting
				</button> */}
			</div>
		</div>
	);
}
